import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgClipboardIconSecondary from './svgs/ClipboardIconSecondary.js';
import SvgClipboardIcon from './svgs/ClipboardIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var clipboardIcon = (props => useIcon(SvgClipboardIcon, SvgClipboardIconSecondary, props));

export { clipboardIcon as default };
